import React from 'react';

const TaxInvoiceHeader = () => (
    <div className="mb-4">
        <h2 className="text-3xl font-bold mb-2" style={{ color: 'var(--primary-color)' }}>
            Tax Invoices
        </h2>
        <p className="text-color-secondary">Generate and manage AMC, domain renewal, SSL and other service invoices billed to your clients</p>
    </div>
);

export default TaxInvoiceHeader;
